export default __webpack_public_path__ + "static/media/android-chrome-192x192.45a92983.png";